import React from "react";

const GroupingSection = (props) => {
  return (
    <div className={props.className}>
      {props?.groups?.map((item) => {
        return (
          <div
            className="category-card"
            onClick={() => props.onSelect("group", item)}
          >
            <div className="category-card-img image-parent">
              <div className="image-inner">
                <img src={item.image} alt="" />
              </div>
            </div>
            <h6>{item.title}</h6>
          </div>
        );
      })}
    </div>
  );
};

export default GroupingSection;
